<script setup lang="ts">
const {
  initialProgress = 0,
  maxProgress = 25,
  fast,
} = defineProps<{
  initialProgress: number;
  maxProgress: number;
  fast?: boolean;
}>();

// While launching, tick the progress bar by small increments up to a given max (based on overall progress)
let progressTimer: ReturnType<typeof setTimeout>;
const progress = ref(initialProgress);
const launchProgressWidth = computed(() => {
  return { width: `${progress.value}%` };
});

watch(
  () => initialProgress,
  (newValue) => {
    progress.value = newValue;
  },
);

function tick() {
  if (progressTimer) {
    clearTimeout(progressTimer);
  }
  let factor: number;
  if (fast) {
    factor = 100;
  } else {
    factor = maxProgress === 75 ? 20000 : 5000;
  }
  let interval = Math.floor(Math.random() * factor);
  if (!fast && interval < 100) {
    interval = 100;
  }
  progressTimer = setTimeout(() => {
    progress.value += 1;
    if (progress.value < maxProgress) {
      tick();
    }
  }, interval);
}

onMounted(() => {
  tick();
});

onUnmounted(() => {
  if (progressTimer) {
    clearTimeout(progressTimer);
  }
});
</script>

<template>
  <div class="launch-progress-bg"></div>
  <div class="launch-progress" :style="launchProgressWidth"></div>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/core/layout/grid-vars' as *;
@use '@clovyr/bed/styles/core/util' as *;

div.launch-progress-bg {
  height: 10px;
  width: 100%;
  border-radius: 8px;
  background-color: #221a33;
  position: absolute;
  top: 0;
}

.launch-progress {
  background-color: #57bb7c;
  height: 10px;
  border-radius: 8px;
  // margin-top: space(1);
  position: absolute;
  z-index: 5;
}
</style>
